import { lazy } from 'react'

export const TanStackRouterDevTools =
  "production" === 'production'
    ? () => null
    : lazy(() =>
        import('@tanstack/router-devtools').then((res) => ({
          default: res.TanStackRouterDevtools
        }))
      )
